export default {
    getVehicleBikByRate: function(vehicle, taxRate) {
        const rate = parseInt(taxRate);
        if (vehicle.biK1Rate === rate) {
            return vehicle.biK1;
        } else if (vehicle.biK2Rate === rate) {
            return vehicle.biK2;
        } else if (vehicle.biK3Rate === rate) {
            return vehicle.biK3;
        } else if (vehicle.biK4Rate === rate) {
            return vehicle.biK4;
        } else if (vehicle.biK5Rate === rate) {
            return vehicle.biK5;
        }

        return 0;
    }
}
